<template>
  <el-row class="container-card el-row">
    <div>
      <TrackDataCard />
      <!-- <TrackBarCard /> -->
      <TerritorialCard />
      <CategoryDataCard />
      <TopVideosCard />
      <TopTracksCard />
      <TopChannelsCard />
      <!-- <TracksCampaign /> -->
    </div>
  </el-row>
</template>

<script>
import TrackDataCard from '@/modules/label/dashboard/components/TrackDataCard'
import TrackBarCard from '@/modules/label/dashboard/components/TrackBarCard'
import TopTracksCard from '@/modules/label/dashboard/components/TopTracksCard'
import TopChannelsCard from '@/modules/label/dashboard/components/TopChannelsCard'
import TopVideosCard from '@/modules/label/dashboard/components/TopVideosCard'
import CategoryDataCard from '@/modules/label/dashboard/components/CategoryDataCard'
import TerritorialCard from '@/modules/label/dashboard/components/TerritorialCard'

export default {
  components: {
    TrackDataCard,
    TrackBarCard,
    TopTracksCard,
    TopChannelsCard,
    TopVideosCard,
    CategoryDataCard,
    TerritorialCard
  },

  data() {
    return {
      line_charts: [
        ['Year', 'Sales', 'Expenses'],
        ['2004', 1000, 400],
        ['2005', 1170, 460],
        ['2006', 660, 1120],
        ['2007', 1030, 540]
      ]
    }
  }
}
</script>
